<template lang="pug">
section
  div
    | Duties that can be carried out
    | via the SMS portal include:

  br

  ul
    li
      | Keep the Home Office up to date
      | with any company changes;
    li
      | Manage certificate of sponsorship
      | for migrant workers;
    li
      | Add, amend or remove
      | any key personnel;
    li
      | Report workers’ activities;
    li
      | Keep up to date
      | with any major rule changes
      | from the Home Office.
</template>

<script>
export default {
  name: "sms_using",
};
</script>